export async function copyToClipboard(text?: string | null) {
  
  if (!text) {
    throw new Error('복사할 링크가 없습니다.');
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return text;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  textarea.style.left = '-9999px';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    const success = document.execCommand('copy');
    if (!success) {
      throw new Error('클립보드 복사에 실패했습니다.');
    }
    return text;
  } finally {
    document.body.removeChild(textarea);
  }
}


type DressTourNoticeSlot = {
  slotDate: string;
  startMinuteOfDay: number;
  shopName: string;
};

type DressTourNoticePayload = {
  slots: DressTourNoticeSlot[];
};

function _formatNoticeDateTime(slotDate: string, startMinuteOfDay: number) {
  const date = new Date(`${slotDate}T00:00:00`);
  const dayNames = ["일", "월", "화", "수", "목", "금", "토"];

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const weekday = dayNames[date.getDay()];

  const hour = Math.floor(startMinuteOfDay / 60);
  const minute = startMinuteOfDay % 60;
  const time = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;

  return `${year}-${month}-${day} (${weekday}) ${time}`;
}

export function buildDressTourNoticeText({ slots }: DressTourNoticePayload) {
  const sortedSlots = [...slots].sort((a, b) => {
    if (a.slotDate !== b.slotDate) return a.slotDate.localeCompare(b.slotDate);
    return a.startMinuteOfDay - b.startMinuteOfDay;
  });

  const slotLines = sortedSlots.flatMap((slot) => [
    _formatNoticeDateTime(slot.slotDate, slot.startMinuteOfDay),
    slot.shopName,
    "",
  ]);

  return [
    "[드레스투어 안내]",
    "",
    ...slotLines,
    "◾ 모든 드레스샵 예약은 1시간 단위로 진행되며, 이동 시간까지해서 2시간 간격으로 투어 일정을 잡아드리고 있습니다!",
    "◾ 드레스 관련 일정은 15분 이상 늦을 시 진행 불가 & 위약금 발생됩니다. 특히나 당일 노쇼는 위약금 발생되기때문에 투어일정은 꼭 투어일 기준 15일 전까지는 미리 변경/취소 말씀해주셔야 합니다! 🙏🙏",
  ].join("\n");
}